import { render, staticRenderFns } from "./KpiCards.vue?vue&type=template&id=4e3e9c0e&scoped=true&"
import script from "./KpiCards.vue?vue&type=script&lang=js&"
export * from "./KpiCards.vue?vue&type=script&lang=js&"
import style0 from "./KpiCards.vue?vue&type=style&index=0&id=4e3e9c0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e9c0e",
  null
  
)

export default component.exports